import React, { useEffect, useState, useRef } from 'react'
import { IBinResponseObj } from '../../Redux/VisualUnits/vuParamSlice'

const DimensionBinList = (props: {
    binList: any[]
    selected : any, 
    handleSelect : Function,
    isFetchingResp: boolean
}) => {
    const { binList, selected, handleSelect, isFetchingResp } = props
    const [selectedBin, setSelectedBin] = useState<number | null>(null)
    let binElementRef = useRef<Map<number, HTMLLIElement>>(new Map())

    useEffect(() => {
        if (selected?.Id !== undefined || selected?.Id !== null || selected?.Id !== "") { //0 can be id
            let index = selected?.Id
            const targetElement = binElementRef.current.get(index)
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
        }
    }, [binList])

    const selectDimensionBinListItem = (itr: IBinResponseObj) => {
        handleSelect(itr)
    }

    return (
        <ul className="dimension-bin-list">
            {binList.length > 0 &&
                binList.map((itr: IBinResponseObj, _index: number) => {
                    return (
                        <li
                            ref={(el) => {
                                if (el) {
                                    binElementRef.current.set(itr.Id, el)
                                }
                            }}
                            id="dimension_bin_item_4"
                            className={selected?.Id === itr.Id ? 'selected' : 'not-selected'}
                            onClick={() => selectDimensionBinListItem(itr)}
                        >
                            <div className="float-left fieldradio">
                                <input
                                    type="radio"
                                    id={`dimension_bin_radio_${itr.Id}`}
                                    name="dimension_bin_radio"
                                    checked={selected?.Id === itr.Id}
                                    value={itr.Id}
                                    readOnly
                                />
                            </div>
                            <div className="float-left fieldcontent">
                                <div className="fieldname">{itr.Name}</div>
                                <div className="fielddesc">{itr.Description}</div>
                            </div>
                            <div className="clear-both"></div>
                        </li>
                    )
                })}
            {!binList.length && !isFetchingResp && <div className="padding-medium medium">No binning available.</div>}
        </ul>
    )
}

export default DimensionBinList
